/** QA UI (dashboards, badges). Set VITE_ENABLE_QUALITY_ASSURANCE=false in .env to hide. */
export const isQualityAssuranceUiEnabled =
  import.meta.env.VITE_ENABLE_QUALITY_ASSURANCE !== 'false';
